module.exports = __webpack_public_path__ + "assets/DoubleAngle.e46683bfe7779a1adc0710907f2f4895.gmt";


//////////////////
// WEBPACK FOOTER
// ./src/resources/levels/Gmt/DoubleAngle.gmt
// module id = 935
// module chunks = 0